// Who sees what in the console — the one place the role groups are named.
//
// The sidebar filters on these, and pages use `useIsOrgAdmin` to drop the
// controls an engineer may not use. Neither is the security boundary: every
// route checks the role server-side (`require_tenant_admin` /
// `require_tenant_builder`). This only keeps the UI from offering what the API
// would refuse.

import { useMe } from "@/lib/query/hooks";
import type { AdminRole } from "@/types/api";

/** Who may build: org admins and engineers. */
export const BUILDERS: AdminRole[] = ["tenant_admin", "engineer"];
/** Org policy, people, credentials — org admins only. */
export const ORG_ADMIN: AdminRole[] = ["tenant_admin"];
/** Roles whose product is the chat app alone. */
export const CHAT_ONLY: AdminRole[] = ["user", "evaluator"];

/** True only for an org admin. False while /me is loading, so admin-only
 *  controls appear once the role is known rather than flashing for everyone. */
export function useIsOrgAdmin(): boolean {
  return useMe().data?.role === "tenant_admin";
}
